import { useEffect, useState } from "react";
import { db } from "../firebase/firebase";
import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";

export default function BatchesPage() {
  const [batches, setBatches] = useState([]);
  const [students, setStudents] = useState([]);

  const [form, setForm] = useState({
    name: "",
    course: "",
    teacher: "",
    startTime: "",
    endTime: "",
    selectedStudents: [],
  });

  // 🔥 Fetch admitted students only
  useEffect(() => {
    const fetchStudents = async () => {
      const q = query(
        collection(db, "students"),
        where("status", "==", "admitted")
      );

      const snap = await getDocs(q);

      const list = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setStudents(list);
    };

    fetchStudents();
  }, []);

  // 🔥 Fetch batches
  useEffect(() => {
    const fetchBatches = async () => {
      const snap = await getDocs(collection(db, "batches"));

      const list = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setBatches(list);
    };

    fetchBatches();
  }, []);

  // ✅ Handle checkbox
  const handleSelectStudent = (id) => {
    setForm((prev) => ({
      ...prev,
      selectedStudents: prev.selectedStudents.includes(id)
        ? prev.selectedStudents.filter((s) => s !== id)
        : [...prev.selectedStudents, id],
    }));
  };

  // ✅ Create batch
  const handleCreateBatch = async () => {
    if (!form.name || form.selectedStudents.length === 0) {
      alert("Fill required fields");
      return;
    }

    await addDoc(collection(db, "batches"), {
      ...form,
      createdAt: new Date(),
    });

    alert("Batch Created ✅");

    // reset
    setForm({
      name: "",
      course: "",
      teacher: "",
      startTime: "",
      endTime: "",
      selectedStudents: [],
    });

    // refresh
    const snap = await getDocs(collection(db, "batches"));
    setBatches(
      snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
    );
  };

  return (
    <div className="p-6 text-white">

      <h1 className="text-2xl font-bold text-orange-500 mb-6">
        Batch Management
      </h1>

      {/* 🧾 CREATE FORM */}
      <div className="bg-white/10 p-6 rounded-xl mb-10 space-y-4">

        <input
          placeholder="Batch Name"
          value={form.name}
          onChange={(e) =>
            setForm({ ...form, name: e.target.value })
          }
          className="w-full p-3 rounded bg-black/40"
        />

        <input
          placeholder="Course"
          value={form.course}
          onChange={(e) =>
            setForm({ ...form, course: e.target.value })
          }
          className="w-full p-3 rounded bg-black/40"
        />

        <input
          placeholder="Teacher"
          value={form.teacher}
          onChange={(e) =>
            setForm({ ...form, teacher: e.target.value })
          }
          className="w-full p-3 rounded bg-black/40"
        />

        <div className="flex gap-4">
          <input
            type="time"
            value={form.startTime}
            onChange={(e) =>
              setForm({ ...form, startTime: e.target.value })
            }
            className="w-full p-3 rounded bg-black/40"
          />

          <input
            type="time"
            value={form.endTime}
            onChange={(e) =>
              setForm({ ...form, endTime: e.target.value })
            }
            className="w-full p-3 rounded bg-black/40"
          />
        </div>

        {/* 👥 STUDENT SELECT */}
        <div className="max-h-40 overflow-y-auto bg-black/30 p-3 rounded">
          {students.map((s) => (
            <label key={s.id} className="block text-sm">
              <input
                type="checkbox"
                checked={form.selectedStudents.includes(s.id)}
                onChange={() => handleSelectStudent(s.id)}
                className="mr-2"
              />
              {s.fullName}
            </label>
          ))}
        </div>

        <button
          onClick={handleCreateBatch}
          className="bg-orange-500 px-6 py-2 rounded"
        >
          Create Batch
        </button>
      </div>

      {/* 📊 BATCH LIST */}
      <div className="grid md:grid-cols-2 gap-6">

        {batches.map((batch) => (
          <div
            key={batch.id}
            className="bg-white/10 p-5 rounded-xl"
          >
            <h2 className="text-lg font-semibold text-orange-400">
              {batch.name}
            </h2>

            <p>Course: {batch.course}</p>
            <p>Teacher: {batch.teacher}</p>
            <p>
              Time: {batch.startTime} - {batch.endTime}
            </p>

            <p className="mt-2 text-sm text-slate-400">
              Students: {batch.selectedStudents?.length || 0}
            </p>
          </div>
        ))}

      </div>

    </div>
  );
}